<mat-card>
  <mat-card-header>
    <mat-card-title>Search for a player</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    This only works for players who have claimed a ticket or joined the server.<br>
    If they haven't done either, you can insert them via the <a routerLink="/create">create</a> page.
    <br><br>
    <app-player-search (selectedPlayerEvent)="select($event)"></app-player-search>
  </mat-card-content>
</mat-card>

<br>

<mat-card *ngIf="player !== null">
  <mat-card-header>
    <img mat-card-md-image src="https://mc-heads.net/avatar/{{player.uuid}}/100" style="padding: 5px;">
    &nbsp;
    <mat-card-title-group>
    <mat-card-title>
      {{player.username}}
      <div *ngFor="let rank of player.ranks">
        <span [style.background-color]="rank.nameColor" style="color: white; padding: 4px; border-radius: 10px;">{{rank.name.toUpperCase()}}</span>&nbsp;
      </div>
      <span *ngIf="muted" style="background-color: #b74c00; color: white; padding: 4px; border-radius: 10px;">MUTED</span>
      <span *ngIf="muted">&nbsp;</span>
      <span *ngIf="banned" style="background-color: #a20000; color: white; padding: 4px; border-radius: 10px;">BANNED</span>
    </mat-card-title>
    <mat-card-subtitle>
      {{player.uuid}}
      <br>
      <span *ngIf="redisPlayer !== null">
        <span *ngIf="redisPlayer.uuid === undefined">
          <span style="color: red">
            Offline
          </span>
          in the Land of Nod!
        </span>
        <span *ngIf="redisPlayer.uuid !== undefined">
          <span style="color: green">
            Online
          </span>
          on {{redisPlayer.server}} ({{redisPlayer.bungeeName}})
        </span>
      </span>
      <br>
      <mat-chip-listbox>
        <mat-chip *ngFor="let role of player.roles" routerLink="/rank/list" [queryParams]="{role: role}">
          {{getRoleName(role)}}
        </mat-chip>
      </mat-chip-listbox>
    </mat-card-subtitle>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Info">
        <mat-spinner *ngIf="eventPass === null"></mat-spinner>
        <div *ngIf="eventPass !== null">
          <mat-grid-list cols="4" rowHeight="3:1">
            <mat-grid-tile>
              <h2 style="display: flex; align-items: center;">
                <mat-icon>calculate</mat-icon>&nbsp;
                {{formatNumber(eventPass.xp)}} XP
              </h2>
            </mat-grid-tile>
            <mat-grid-tile>
              <h2 style="display: flex; align-items: center;">
                <mat-icon>leaderboard</mat-icon>&nbsp;
                Level {{eventPass.level}}
              </h2>
            </mat-grid-tile>
            <mat-grid-tile>
              <h2 style="display: flex; align-items: center;">
                <mat-icon>payments</mat-icon>&nbsp;
                {{formatNumber(playerCoins!)}} Coins
              </h2>
            </mat-grid-tile>
            <mat-grid-tile *ngIf="eventPass.team">
              <h2 style="display: flex; align-items: center;">
                <mat-icon>group</mat-icon>&nbsp;
                Team&nbsp;
                <span [style.color]="getTeamName()">
                  {{getTeamName()}}
                </span>
              </h2>
            </mat-grid-tile>

          </mat-grid-list>
        </div>
      </mat-tab>
      <mat-tab label="Punishments">
        <table mat-table [dataSource]="punishments">
          <ng-container matColumnDef="player">
            <th mat-header-cell *matHeaderCellDef>Player</th>
            <td mat-cell *matCellDef="let p">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.player.uuid}}/20"> &nbsp;
        {{p.player.username}}
      </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="mod">
            <th mat-header-cell *matHeaderCellDef>Moderator</th>
            <td mat-cell *matCellDef="let p">
      <span style="display: flex; align-items: center">
        <img src="https://mc-heads.net/avatar/{{p.moderator.uuid}}/20"> &nbsp;
        {{p.moderator.username}}
      </span>
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let p">
              {{p.type}}
            </td>
          </ng-container>
          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef>Reason</th>
            <td mat-cell *matCellDef="let p">
              {{p.reason}}
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let p">
      <span *ngIf="p.quashed" style="display: flex; align-items: center">
        Overturned by &nbsp;
        <img src="https://mc-heads.net/avatar/{{p.quashedBy!.uuid}}/20"> &nbsp;
        {{p.quashedBy!.lastUsername}}
      </span>
              <span style="display: flex; align-items: center" *ngIf="!p.quashed">
        {{getStatus(p)}}&nbsp;
        <button mat-icon-button *ngIf="isActive(p) && apiService.hasEntitlement(authService.user!.entitlements, 'MODERATION')" (click)="quash(p)"><mat-icon>undo</mat-icon></button>
      </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="punishColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: punishColumns"></tr>
        </table>

      </mat-tab>
      <!--<mat-tab label="Autographs">
        <mat-spinner *ngIf="autographs.length === 0"></mat-spinner>
        <div *ngIf="autographs.length !== 0">
          <table mat-table [dataSource]="autographs">
            <ng-container matColumnDef="giver">
              <th mat-header-cell *matHeaderCellDef>Giver</th>
              <td mat-cell *matCellDef="let p" (click)="select(p.giver)">
                <span style="display: flex; align-items: center">
                  <img src="https://mc-heads.net/avatar/{{p.giver.uuid}}/20"> &nbsp;
                  {{p.giver.lastUsername}}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="receiver">
              <th mat-header-cell *matHeaderCellDef>Receiver</th>
              <td mat-cell *matCellDef="let p" (click)="select(p.player)">
                <span style="display: flex; align-items: center">
                  <img src="https://mc-heads.net/avatar/{{p.player.uuid}}/20"> &nbsp;
                  {{p.player.lastUsername}}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="text">
              <th mat-header-cell *matHeaderCellDef>Text</th>
              <td mat-cell *matCellDef="let p">
                {{p.text}}
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let p">
                <button mat-icon-button>
                  <mat-icon>cancel</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="autographColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: autographColumns"></tr>
          </table>
        </div>
      </mat-tab>!-->
      <mat-tab label="Attendance">
        <mat-spinner *ngIf="eventPass === null"></mat-spinner>
        <div *ngIf="eventPass !== null">
          <table mat-table [dataSource]="attendance">
            <ng-container matColumnDef="year">
              <th mat-header-cell *matHeaderCellDef>Year</th>
              <td mat-cell *matCellDef="let p">
                {{p.year}}
              </td>
            </ng-container>
            <ng-container matColumnDef="rank">
              <th mat-header-cell *matHeaderCellDef>Rank</th>
              <td mat-cell *matCellDef="let p">
                {{p.ranks.join(', ')}}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns"></tr>
            <tr mat-row *matRowDef="let row; columns: columns"></tr>
          </table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <button [disabled]="!apiService.hasEntitlement(authService.user!.entitlements, 'MODERATION')" mat-button color="warn" (click)="openPunish()">Punish</button>
    <button [disabled]="!apiService.hasEntitlement(authService.user!.entitlements, 'OPERATIONS')" mat-button (click)="openRank()">Edit Rank</button>
    <button [disabled]="!apiService.hasEntitlement(authService.user!.entitlements, 'OPERATIONS')" mat-button (click)="openRole()">Edit Role</button>
    <button [disabled]="!apiService.hasEntitlement(authService.user!.entitlements, 'OPERATIONS')" mat-button (click)="openCoins()">Edit Coins</button>
  </mat-card-actions>
</mat-card>


